<template>
  <v-card max-width="1400px">
    <span class="red--text">{{ errorMessage }}</span>
    <v-card-title> DISTRIBUCIONES </v-card-title>

    <v-card-text>
      <periodo-distribucion-autocomplete @periodoDistribucion="setPeriodoDistribucion"
        :periodoDistribucion="periodoDistribucion" clearable />
      <tipo-generacion-autocomplete @tipoGeneracion="setTipoGeneracion" clearable />
      <v-data-table :loading="loading" item-class="class" :headers="headers" dense :items="generacionesFiltrado"
        disable-sort>
        <template v-slot:item.fechaInicio="{ item }">
          {{ item.fechaInicio | dateFormat }}
        </template>
        <template v-slot:item.fechaFin="{ item }">
          {{ item.fechaFin | dateFormat }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on">
                <v-icon>arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <v-list expand>
              <v-list-item>
                <v-btn :loading="loading" block color="warning" small @click.once="descargarTotales(item)">Descargar
                  Totales</v-btn>
              </v-list-item>

              <!-- <v-list-item>
                <v-btn :loading="loading" block color="warning" small
                  @click.once="descargarTotalesPendientes(item)">Descargar
                  Totales Pendientes</v-btn>
              </v-list-item> -->

              <v-list-item>
                <v-btn :loading="loading" block color="warning" small
                  @click.once="descargarTotalesPagados(item)">Descargar Totales
                  Pagado</v-btn>
              </v-list-item>

              <v-list-item>
                <v-btn :loading="loading" block color="" small @click.once="descargarOnis(item)">Descargar
                  ONIS</v-btn>
              </v-list-item>

            </v-list>
          </v-menu>

        </template>
      </v-data-table>
    </v-card-text>

    <v-card-actions>
      <v-btn @click="$router.push({ path: '/' })">VOLVER</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="info" small @click="descargarEstadosPagos()" :loading="loadingReport"
        :disabled="true || !$store.getters.user.roles.includes('CONSULTAPAGOS')">Descargar estados de pagos</v-btn>
      <v-spacer></v-spacer>
      <v-btn :disabled="!periodoDistribucion" @click="imprimirComparativo" small><v-icon right>print</v-icon>COMPARATIVO
        BOLSAS</v-btn>
      <v-btn :disabled="!periodoDistribucion" small @click="imprimirLista"><v-icon right>print</v-icon>LISTA DE
        DISTRIBUCIONES</v-btn>
      <v-spacer></v-spacer>

      <v-dialog scrollable max-width="600px" v-model="showDialog">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="info" small :loading="loadingReport"
            :disabled="!$store.getters.user.roles.includes('CONSULTAPAGOS')">Descargar PAGADOS</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <h4>Ingrese los datos solicitados</h4>
          </v-card-title>
          <v-card-text>
            <v-form ref="form">

              <periodo-distribucion-autocomplete @periodoDistribucion="setPeriodoDistribucion"
                :periodoDistribucion="periodoDistribucion" clearable />

              <GeneracionAutocomplete returnObject :required=false :filtroEstado="[
                'Pendiente',
                'Cerrado',
                'Liquidado',
                'Liquidando',
              ]" @generacionId="setGeneracion" />

              <v-row class="pa-3 mb-1">
                <MyDatePicker :fecha="formatDate(fechaDesde)" label="Fecha pago desde" @fecha="setFechaDesde"
                  :rules="[rules.required]" />
                <MyDatePicker :fecha="formatDate(fechaHasta)" label="Fecha pago hasta" @fecha="setFechaHasta"
                  :rules="[rules.required]" />
              </v-row>
            </v-form>

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="info" @click="showDialog = false" small>Volver</v-btn>
            <v-btn color="info" small @click="descargarEstadosPagosContabilidadPagados()"
              :loading="loadingReport">Descargar
              PAGADOS</v-btn>

            <v-btn color="info" small @click="descargarTotalesFecha()"
              :loading="loadingReport"
              :disabled="!fechaDesde || !fechaHasta">Descargar
              PAGADOS PDF (por fecha)</v-btn>


          </v-card-actions>
        </v-card>
      </v-dialog>



      <v-spacer></v-spacer>
      <DescargarPendientesFiltro />
      <!-- <v-btn color="info" small @click="descargarEstadosPagosContabilidadPendientes()"
      :loading="loadingReport" :disabled="!$store.getters.user.roles.includes('CONSULTAPAGOS')">Descargar PENDIENTES</v-btn> -->
      <v-spacer></v-spacer>

      <Resumen />
    </v-card-actions>




  </v-card>




</template>
<script>
import axios from "axios";
import { saveAs } from "file-saver";
import Resumen from "../components/pago/Resumen.vue";
import MyDatePicker from "@/components/shared/MyDatePicker";
import PeriodoDistribucionAutocomplete from "@/components/shared/PeriodoDistribucionAutocomplete.vue";
import TipoGeneracionAutocomplete from "@/components/shared/TipoGeneracionAutocomplete.vue";
import DescargarPendientesFiltro from "@/components/consultaPago/DescargarPendientesFiltro.vue";
import GeneracionAutocomplete from "@/components/shared/GeneracionAutocomplete.vue";
import moment from "moment";

export default {
  data() {
    return {
      generaciones: [],
      generacion: null,
      periodoDistribucion: null,
      generacionesFiltrado: [],
      tipoGeneracion: null,
      liquidando: false,
      errorMessage: "",
      loading: false,
      loadingReport: false,
      showDialog: false,
      fechaDesde: '',
      fechaHasta: '',
      rules: {
        required: (value) => !!value || "Requerido.",
      },
      headers: [
        { text: 'Periodo', value: 'periodoDistribucion.descripcion' },
        { text: 'Inicio', value: 'fechaInicio' },
        { text: 'Fin', value: 'fechaFin' },
        { text: 'id', value: 'id' },
        { text: 'Tipo', value: 'tipoGeneracion.descripcion' },
        { text: 'Nombre corto', value: 'nombreCorto' },
        {
          text: 'Descripcion',
          align: 'start',
          sortable: false,
          value: 'descripcion',
        },
        { text: 'Accion', value: 'actions' },
      ]

    };
  },
  components: {
    Resumen,
    TipoGeneracionAutocomplete,
    MyDatePicker,
    DescargarPendientesFiltro,
    GeneracionAutocomplete,
    PeriodoDistribucionAutocomplete,
  },
  mounted() {
    this.refresh();
  },
  filters: {
    dateFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
  },
  methods: {
    doFilter() {


      if (this.tipoGeneracion == null && this.periodoDistribucion == null) {
        this.generacionesFiltrado = this.generaciones;
        return;
      }

      this.generacionesFiltrado = this.generaciones.filter((g) => {

        const coincideTipo = this.tipoGeneracion == null || (this.tipoGeneracion != null && g.tipoGeneracion?.id === this.tipoGeneracion.id);
        const coincidePeriodo = this.periodoDistribucion == null || (this.periodoDistribucion != null && g.periodoDistribucion?.id === this.periodoDistribucion.id);

        return coincideTipo && coincidePeriodo;
      });
      console.log('********', this.generacionesFiltrado.length)


    },
    imprimirComparativo() {
      this.loading = true;
      axios.post("/reports", {
        dbName: "SIAPA",
        reportName: "comparativo_bolsa_distribucion.jrxml",
        base64: true,
        params: [
          { nombre: "ID_PERIODO", valor: this.periodoDistribucion.id, tipo: "integer" },
          { nombre: "USUARIO", valor: this.$store.getters.user.username }
        ],
      })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.errorMessage = err.response.data;
        });
    },
    imprimirLista() {
      this.loading = true;
      axios.post("/reports", {
        dbName: "SIAPA",
        reportName: "reporte_generaciones_periodo.jrxml",
        base64: true,
        params: [
          { nombre: "ID_PERIODO", valor: this.periodoDistribucion.id, tipo: "integer" },
          { nombre: "USUARIO", valor: this.$store.getters.user.username }
        ],
      })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.errorMessage = err.response.data;
        });
    },
    setPeriodoDistribucion(e) {
      this.periodoDistribucion = e;
      this.doFilter();
    },
    setGeneracion(generacion) {
      this.generacion = generacion;
    },
    setFechaDesde(fecha) {
      console.log("fecha inicio seleccionada", fecha);
      this.fechaDesde = fecha;
    },
    setFechaHasta(fecha) {
      console.log("fecha fin seleccionada", fecha);
      this.fechaHasta = fecha;
    },

    setTipoGeneracion(e) {
      this.tipoGeneracion = e;
      this.doFilter();
    },
    async refresh() {

      this.loading = true;
      await axios.get("/generaciones")
        .then((response) => {
          this.generaciones = response.data.map((g) => {
            // return {groupBy: g.fechaInicio + ' - ' + g.fechaFin, ...g };
            return { ...g, class: 'green lighten-5' };
          });

          //Ordenamos
          this.generaciones.sort((a, b) =>
            // (b.fechaInicio || '').localeCompare(a.fechaInicio || '') ||
            // (b.fechaFin || '').localeCompare(a.fechaFin || '')
            b.id - a.id
          );

          this.generacionesFiltrado = this.generaciones;

          this.setTipoGeneracion(this.tipoGeneracion);

        })
        .catch((err) => {
          console.log(err);
        });

      this.loading = false;

    },

    descargarTotales(generacion) {
      this.loadingReport = true;
      axios.post("/reports", {
        dbName: "SIAPA",
        reportName: "escenarioTotales.jrxml",
        base64: true,
        params: [
          { nombre: "generacion_id", valor: generacion.id, tipo: "integer" },
          { nombre: "usuario", valor: this.$store.getters.user.username }
        ],
      })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loadingReport = false;
        })
        .catch((err) => {
          console.log(err);
          this.loadingReport = false;
          this.errorMessage = err.response.data;
        });
    },
    descargarTotalesFecha() {
      this.loadingReport = true;
      axios.post("/reports", {
        dbName: "SIAPA",
        reportName: "totalesPagados_x_fecha.jrxml",
        base64: true,
        params: [
          { nombre: "fecha_desde", valor: this.fechaDesde, tipo: "dateymd" },
          { nombre: "fecha_hasta", valor: this.fechaHasta, tipo: "dateymd" },
          { nombre: "usuario", valor: this.$store.getters.user.username }
        ],
      })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loadingReport = false;
        })
        .catch((err) => {
          console.log(err);
          this.loadingReport = false;
          this.errorMessage = err.response.data;
        });
    },
    descargarTotalesPendientes(generacion) {
      this.loadingReport = true;
      axios
        .get("/report/generacion/totalesPendientes/" + generacion.id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loadingReport = false;
          // this.$store.dispatch("showSnack", "Descargando..!");
        })
        .catch((err) => {
          this.loadingReport = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
          // this.$store.dispatch("showSnack", "Error");
        });
    },
    descargarTotalesPagados(generacion) {
      this.loadingReport = true;
      axios
        .get("/report/generacion/totalesPagados/" + generacion.id)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loadingReport = false;
          // this.$store.dispatch("showSnack", "Descargando..!");
        })
        .catch((err) => {
          this.loadingReport = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
          // this.$store.dispatch("showSnack", "Error");
        });
    },
    descargarEstadosPagos() {
      this.loadingReport = true;
      axios
        .get("/report/estadosPagos/")
        .then((response) => {

          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/excel",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loadingReport = false;
        })
        .catch((err) => {
          this.loadingReport = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    descargarEstadosPagosContabilidadPagados() {
      this.loadingReport = true;

      const params = {
        generacionId: this.generacion ? this.generacion.id : null,
        fechaDesde: this.fechaDesde ? this.fechaDesde : null,
        fechaHasta: this.fechaHasta ? this.fechaHasta : null,
        idPeriodoDistribucion: this.periodoDistribucion ? this.periodoDistribucion.id : null,
      };

      let url = "/report/estadosPagosContabilidadPagados";

      axios
        .get(url, { params })
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/excel",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loadingReport = false;
          this.showDialog = false;
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
          this.loadingReport = false;
        });
    },
    descargarEstadosPagosContabilidadPendientes(generacion) {
      this.loadingReport = true;

      let url;
      if (generacion) {
        url = "/report/estadosPagosContabilidadPendientes?generacionId=" + generacion.id;
      } else {
        url = "/report/estadosPagosContabilidadPendientes";
      }

      axios
        .get(url)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/excel",
            null
          );
          saveAs(blob, response.data.fileName);
          this.loadingReport = false;
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
          this.loadingReport = false;
        });
    },
    descargarOnis(generacion) {
      this.loading = true;
      axios
        .get("/report/generacion/onis/" + generacion.id)
        .then((response) => {
          this.loading = false;
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
          // this.$store.dispatch("showSnack", "Descargando..!");
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
          // this.$store.dispatch("showSnack", "Error");
        });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    formatDate(date) {
      if (!date) return null;

      if (!moment(date, "YYYY-MM-DD", true).isValid()) {
        this.date = null;
        return null;
      }

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>